import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets.v2/images/logo-sign-up.svg'


const _hoisted_1 = { class: "sign-up pop-up" }
const _hoisted_2 = { class: "sign-up__inner" }
const _hoisted_3 = { class: "sign-up__form-box" }
const _hoisted_4 = { class: "shortform-sign-up" }
const _hoisted_5 = { class: "shortform-sign-up__title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = { class: "account-deletion-confirmation__group" }
const _hoisted_12 = { class: "account-deletion-confirmation__group" }
const _hoisted_13 = {
  type: "submit",
  class: "btns btns--largest btns--red btns--full account-deletion-btn",
  "data-test-id": "delete-account"
}

import { ref, onBeforeMount, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useWait } from '@/app/composables/useWait'

import { authCssFix } from '@/helpers/html'

import FormError from '@/components/ui/FormError.vue'
import { backend } from '@/services/backend'
import { ValidationState } from '@/helpers/form'
import { AccountStatus } from '@/models/interfaces'
import { Sentry } from '@/services/sentry'
import AccountStatusInfo from '@/app/components/account/AccountStatusInfo.vue'
import { notificationService } from '@/services/notification'
import { localLogout } from '@/services/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountDeletionConfirmation',
  setup(__props) {

const route = useRoute()
const wait = useWait()

const validation = ref(new ValidationState())
const accountStatus = ref<AccountStatus | null>(null)
const deletionConfirmationComplete = ref(false)
const hasError = ref(false)

onBeforeMount(async () => {
  try {
    const token = route.query.delete_token
    if (token) {
      accountStatus.value = await backend.getAccountStatusByDeleteToken(
        token as string,
      )
    } else {
      accountStatus.value = await backend.getAccountStatus()
    }
  } catch (error) {
    // The error here is usually NetworkError or Timeout, but
    // we still capture all errors to Sentry to be aware if
    // error rate increases.
    Sentry.withScope(function (scope) {
      scope.setFingerprint(['account-status-loading-error'])
      Sentry.captureException(error)
    })
    hasError.value = true
    validation.value.showErrors(error)
  }
})

onMounted(() => {
  authCssFix()
})

async function confirmDeletion(): Promise<void> {
  validation.value.reset()

  try {
    wait.start('Deleting')
    await notificationService.unsubscribe()

    const token = route.query.delete_token
    await backend.confirmAccountDeletion(token as string)
    deletionConfirmationComplete.value = true

    try {
      await localLogout()
    } catch (err) {
      // Ignore any errors raised here.
    }

    wait.end('Deleting')
  } catch (error) {
    wait.end('Deleting')
    hasError.value = true
    Sentry.captureException(error)
    validation.value.showErrors(error)
  }
}

const title = computed(() => {
  return deletionConfirmationComplete.value
    ? 'Account Deleted'
    : 'Confirm Account Deletion'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sign-up__content" }, [
        _createElementVNode("div", { class: "sign-up__logo-text-box" }, [
          _createElementVNode("a", {
            class: "sign-up__logo",
            href: "/"
          }, [
            _createElementVNode("img", {
              class: "sign-up__logo-img",
              src: _imports_0,
              alt: "Shortform"
            })
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(title.value), 1),
          (deletionConfirmationComplete.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "confirmation-completed-text" }, " Your account has been deleted. You won't be able to log in anymore with this email. You can always create a new account if you want to join Shortform again. ", -1)),
                _createVNode(_component_router_link, {
                  to: { name: 'signup' },
                  class: "btns btns--largest btns--full account-deletion-btn",
                  "data-test-id": "ok-button"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("Ok", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[7] || (_cache[7] = _createElementVNode("p", null, "Are you sure you want to delete your account?", -1)),
                (accountStatus.value === null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(FormError, {
                        errors: validation.value.errors,
                        field: "delete_token",
                        class: "error-message"
                      }, null, 8, ["errors"]),
                      _createVNode(FormError, {
                        errors: validation.value.errors,
                        field: "_schema",
                        class: "error-message"
                      }, null, 8, ["errors"]),
                      (hasError.value)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'billing' },
                            class: "btns btns--largest btns--full account-deletion-btn",
                            "data-test-id": "cancel-subscription"
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("Go to the billing page", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("p", null, [
                        _createVNode(AccountStatusInfo, { "account-status": accountStatus.value }, null, 8, ["account-status"])
                      ]),
                      (hasError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString('Failed to delete account. Please try again or contact support at help@shortform.com.')))
                        : _createCommentVNode("", true),
                      (hasError.value)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: { name: 'billing' },
                            class: "btns btns--largest btns--full account-deletion-btn",
                            "data-test-id": "cancel-subscription"
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("Go to the billing page", -1)
                            ]))]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock("form", {
                            key: 2,
                            class: "shortform-sign-up__form",
                            onSubmit: _withModifiers(confirmDeletion, ["prevent"])
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_router_link, {
                                to: { name: 'home' },
                                class: "btns btns--largest btns--full account-deletion-btn",
                                "data-test-id": "keep-account"
                              }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode("Keep my account", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_13, [
                                _createVNode(_component_v_wait, { for: "Deleting" }, {
                                  waiting: _withCtx(() => [
                                    _cache[5] || (_cache[5] = _createTextVNode(" Deleting ", -1)),
                                    _createVNode(_component_button_spinner)
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "Delete account", -1))
                                  ]),
                                  _: 1
                                })
                              ])), [
                                [_directive_wait, 'Deleting', "disabled"]
                              ])
                            ])
                          ], 32))
                    ]))
              ]))
        ])
      ])
    ])
  ]))
}
}

})